

export const CAREER_HERO_ASSETS = {
  heroImage: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/hero-courses.png"
};